<template>
  <div v-if="loading" class="chat-bot-loader-wrapper">
    <LinkLoader />
  </div>
  <div class="messenger-bot-links" v-if="chatBotLinks.length">
    <span class="messenger-bot-links__title"
      ><div v-html="downloadLinksTitle"></div>
    </span>
    <div
      class="messenger-bot-links__options-list"
      v-for="messenger in chatBotLinks"
      :key="messenger.url"
    >
      <a
        v-if="this.getMessengerStoreLinks(messenger.name).length === 1"
        class="messenger-bot-links__options-list__item"
        target="_blank"
        :href="this.getMessengerStoreLinks(messenger.name)[0].url"
      >
        <img :src="require(`@/assets/img/${messenger.img}`)" />{{
          messenger.helpMessage
        }}
      </a>
      <ButtonLink
        v-else
        :messengerLinks="this.getMessengerStoreLinks(messenger.name)"
      >
        <img :src="require(`@/assets/img/${messenger.img}`)" />{{
          messenger.helpMessage
        }}
      </ButtonLink>
    </div>
    <span class="messenger-bot-links__title"
      ><div v-html="downloadLinksBottom"></div
    ></span>
  </div>
</template>

<script>
import { mapState } from "vuex";
import LinkLoader from "./LinkLoader.vue";
import ButtonLink from "@/components/ButtonLink.vue";

export default {
  name: "MessengerDownloadLinks",
  components: {
    ButtonLink,
    LinkLoader,
  },
  computed: {
    ...mapState([
      "chatBotLinks",
      "loading",
      "downloadLinksTitle",
      "downloadLinksBottom",
    ]),
  },
  methods: {
    getMessengerStoreLinks: function (messenger) {
      const os = this.getCurrentOs();

      let links = [];

      switch (messenger) {
        case "telegram":
          switch (os) {
            case "iphone":
              links.push({
                name: "ios",
                url: "https://apps.apple.com/ru/app/telegram-messenger/id686449807",
                image: "app-store-icon.svg",
              });
              break;
            case "android":
              links.push({
                name: "google",
                url: "https://play.google.com/store/apps/details?id=org.telegram.messenger",
                image: "google-play-icon.svg",
              });
              links.push({
                name: "rustore",
                url: "https://apps.rustore.ru/app/org.telegram.messenger.web",
                image: "ru-store-icon.svg",
              });
              links.push({
                name: "huawei",
                url: "https://appgallery.cloud.huawei.com/ag/n/app/C101184875?locale=ru_RU&source=appshare&subsource=C101184875&shareTo=org.telegram.messenger&shareFrom=appmarket&shareIds=858a4b7686434a4fb80271e3d76c76cf_org.telegram.messenger&callType=SHARE",
                image: "appgallery-icon.svg",
              });
              break;
            default:
              links.push({
                name: "desktop",
                url: "https://telegram.org/apps",
                image: "ru-store-icon.svg",
              });
              break;
          }
          break;

        case "whatsapp":
          switch (os) {
            case "iphone":
              links.push({
                name: "ios",
                url: "https://apps.apple.com/ru/app/whatsapp-messenger/id310633997",
                image: "app-store-icon.svg",
              });
              break;
            case "android":
              links.push({
                name: "google",
                url: "https://play.google.com/store/apps/details?id=com.whatsapp",
                image: "google-play-icon.svg",
              });
              links.push({
                name: "huawei",
                url: "https://appgallery.cloud.huawei.com/ag/n/app/C949879061277062784?locale=ru_RU&source=appshare&subsource=C949879061277062784&shareTo=org.telegram.messenger&shareFrom=appmarket&shareIds=213024c25a8b46c2add0bdd96fa152f5_org.telegram.messenger&callType=SHARE",
                image: "appgallery-icon.svg",
              });
              break;
            default:
              links.push({
                name: "desktop",
                url: "https://www.whatsapp.com/download",
                image: "ru-store-icon.svg",
              });
              break;
          }
          break;

        default:
          return links;
      }
      return links;
    },
    getCurrentOs: function () {
      if (navigator.userAgent.toLowerCase().indexOf("iphone") > -1) {
        return "iphone";
      }

      if (navigator.userAgent.toLowerCase().indexOf("android") > -1) {
        return "android";
      }

      if (
        !navigator.userAgent.match(
          /(iPhone|iPod|iPad|Android|BlackBerry|IEMobile)/
        )
      ) {
        return "desktop";
      }

      return "desktop";
    },
  },
};
</script>

<style lang="scss">
.messenger-bot-links {
  font-size: 1.2em;
  padding: 1rem;
  margin: 1em 0;
  border-radius: $border-radius;
  min-height: 100px;
  @extend %app-box-shadow;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  align-items: center;

  &__title {
    text-align: center;
  }
  &__options-list {
    margin: 1rem;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex: 1;
    position: relative;
    &__item {
      $item-value: 4rem;
      height: $item-value;
      width: $item-value;

      @media (min-width: 375px) {
        $item-value: 5rem;
        height: $item-value;
        width: $item-value;
      }

      margin: 1rem;
      img {
        display: block;
        height: 100%;
        width: 100%;
      }
    }
  }
}
.button {
  &__link {
    padding: 0px;
    $item-value: 4rem;
    height: $item-value;
    width: $item-value;

    @media (min-width: 375px) {
      $item-value: 5rem;
      height: $item-value;
      width: $item-value;
    }

    margin: 0rem;
    img {
      display: block;
      height: 100%;
      width: 100%;
    }
  }
}
</style>
